import React from 'react';
import { Heart, HelpCircle } from 'react-feather';

function WaiverPaymentsGrid({ formData, onDataChange }) {
  const tooltipText = "Payments for providing care to an eligible individual under a state Medicaid waiver program.";

  return (
    <div className="form-section">
      <div className="content-box-header">
        <div className="header-title-with-help">
          <h2><Heart size={20} className="icon-orange" /> Medicaid Waiver Payments</h2>
          <div className="has-tooltip header-help-icon" data-tooltip={tooltipText}>
            <HelpCircle size={18} />
          </div>
        </div>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#553f33ff' }}>Total Waiver Payments</label>
          <p style={{ fontSize: '0.9rem', color: '#8b7464ff', marginBottom: '0.75rem' }}>
            Enter the total amount of difficulty-of-care payments received.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualWaiverPayments" 
              value={formData?.manualWaiverPayments ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
        
        <div style={{ marginTop: '1rem', padding: '10px', backgroundColor: '#fff7ed', borderRadius: '5px', border: '1px solid #fed7aa' }}>
          <small style={{ display: 'block', color: '#9a3412' }}>
            <strong>Note:</strong> If you have taxable dependent care benefits from Box 10 of your W-2, please enter those in the "Deductions & Credits" tab.
          </small>
        </div>
      </div>
    </div>
  );
}

export default WaiverPaymentsGrid;